import type { VoidFunctionComponent } from 'react';
import Header from '../../../shared/settings/SettingsPageHeader';
import PrivacySection from './PrivacySection';
import GithubStatusCheckSection from './GithubStatusCheckSection';
import { shouldDisplayProjectGeneralSettings } from '../../shared/permissions';
import OrganizationSettingsPermissionGate from '../../OrganizationSettingsPermissionGate';

/**
 * SettingsOrganizationProjectGeneral is the settings page for managing
 * the global project settings.
 */
const SettingsOrganizationProjectGeneral: VoidFunctionComponent = () => {
  return (
    <>
      <Header heading="Default General Settings" />
      <PrivacySection />
      <GithubStatusCheckSection />
    </>
  );
};

/**
 * SettingsOrganizationProjectGeneralContainer displays the project general settings page if the user has permission to view it.
 */
const SettingsOrganizationProjectGeneralContainer: VoidFunctionComponent = () => (
  <OrganizationSettingsPermissionGate checkPermission={shouldDisplayProjectGeneralSettings}>
    <SettingsOrganizationProjectGeneral />
  </OrganizationSettingsPermissionGate>
);

export default SettingsOrganizationProjectGeneralContainer;
